import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const root = css`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${spacing.md}px;
  color: var(--neutral-black-70);

  h3 {
    margin: 0 0 ${spacing.base}px 0;
    ${responsiveText.HEADING.SM};
    color: var(--brand-bluple-base);
  }

  p {
    margin: 0 0 ${spacing.md}px 0;
    ${responsiveText.BODY.SM};
    color: var(--neutral-black-base);
  }
`;
